import Text from '@/components/custom-ui/text'
import { ImageAd } from '@/lib/api/navigation/navigation.types'
import Image from 'next/image'

const MenuImage = ({ url, title, description }: ImageAd) => {
  return (
    <div
      className={'relative aspect-[3/4] w-full max-w-[320px] md:max-w-[430px]'}
    >
      <Image
        priority
        width={430}
        height={580}
        quality={100}
        src={url}
        alt={url}
        className={'absolute inset-0 h-full w-full object-cover transition-all'}
      />

      <div className="absolute inset-0 flex h-full flex-col items-start justify-end gap-3 px-8 pb-10 text-white">
        <Text as="p" className="text-[10px] uppercase" fontWeight={'bold'}>
          {title}
        </Text>

        <Text as="h3" className="uppercase">
          {description}
        </Text>
      </div>
    </div>
  )
}

export default MenuImage
